var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "feature-buttons" }, [
    !_vm.homeScreenComponents
      ? _c(
          "div",
          [
            _c(
              "b-button",
              {
                staticClass: "py-2 greenBtn",
                attrs: { variant: "success", title: "Home" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("returnHome")
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "home"], size: "lg" } })],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }